export default __webpack_public_path__ + "media/images/logos/plus-divide-blue-plus-d73f57cab5418c640487a4246f265da4.svg";